import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { SoundService } from "appworks/services/sound/sound-service";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { BannerComponent } from "slotworks/components/banner/banner-component";
import { BetBarComponent } from "slotworks/components/betbar/bet-bar-component";
import { CelebrateWinComponent } from "slotworks/components/celebrate-win/celebrate-win-component";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { slotDefinition } from "slotworks/model/slot-definition";
import { slotModel } from "slotworks/model/slot-model";
import { AutoplayService } from "slotworks/services/autoplay/autoplay-service";

export interface EnterFreespinsStateConfig {
    setToFreespinsReelset: boolean;
}

export class EnterFreespinsState extends State {
    protected config: EnterFreespinsStateConfig = {
        /** @todo - make this true by default in next beta */
        setToFreespinsReelset: false
    };

    constructor(config?: Partial<EnterFreespinsStateConfig>) {
        super();

        if (config) {
            this.config = { ...this.config, ...config };
        }
    }

    public onEnter() {
        super.onEnter();

        if (slotModel.read().autoplay.stopOnFeatureWin) {
            Services.get(AutoplayService).stop();
        }

        Components.get(CelebrateWinComponent)?.cleanup();
        Components.get(CelebrateWinComponent)?.hide();

        uiFlags.set(UIFlag.PROMPT, true);

        this.showPrompt();

        if (this.config.setToFreespinsReelset) {
            this.setReelset();
        }

        Services.get(SoundService).event(SoundEvent.enter_freespins);
    }

    public complete() {
        this.showFreespinsElements();

        uiFlags.set(UIFlag.PROMPT, false);
        uiFlags.set(UIFlag.FREE_SPINS, true);

        this.updateFreespinsBetbar();

        super.complete();
    }

    protected updateFreespinsBetbar(): void {
        const game = gameState.getCurrentGame();

        Components.get(BetBarComponent).setTotalFreespins(game.getTotalFreespinsWon());
        Components.get(BetBarComponent).setFreespinsPlayed(Math.max(0, game.getFreespinsPlayed() + 1));
    }

    // To set up custom options on a prompt, extend this, initialise your prompt and pass it to super
    protected showPrompt(prompt?: PromptContentSubcomponent, loadStage?: number) {
        if (!prompt && Layers.get("Prompts").hasAnyScene(["freespinswin", "freespins"])) {
            prompt = new PromptContentSubcomponent(["freespinswin", "freespins"], 2000);
        }

        if (prompt) {
            const record = gameState.getCurrentGame().getCurrentRecord();

            prompt.setText("winMessage", Services.get(TranslationsService).getFirstValid(
                ["fs.tri", "you_won_x_freespins"],
                { VALUE: record.getFreespinsWon(), freespins: record.getFreespinsWon() }
            ));
            prompt.setText("value", record.getFreespinsWon().toString());
            prompt.addContinueButton("continue");

            Components.get(PromptComponent).showPrompt(prompt, loadStage).then(() => this.complete());
        } else {
            this.complete();
        }
    }

    protected showFreespinsElements() {
    
        if (Layers.get("MatrixBackground")?.hasScene("freespins")) {
            Layers.get("MatrixBackground").setScene("freespins").execute();
        }
        if (Layers.get("MatrixForeground")?.hasScene("freespins")) {
            Layers.get("MatrixForeground").setScene("freespins").execute();
        }
       
        Components.get(BannerComponent)?.setMode("freespins");
    }

    protected setReelset() {
        if (slotDefinition.reelsets.get("freespins")) {
            Components.get(AbstractMatrixComponent).setCustomReelset(slotDefinition.reelsets.get("freespins"));
        }
    }
}
